// extracted by mini-css-extract-plugin
module.exports = {"rotation":"CollezioniSection_rotation__kWbV_"};